import { useCallback } from 'react';
import type { ComponentProps } from 'react';

import type { ApiAddressWithFormData } from '#/api/types/ApiAddress';
import { useFormContext } from '#/components/Form/FormContext';

import { AddressFormContainerInternal } from './AddressFormContainerInternal';

type AddressFieldsContainerProps = Omit<
  ComponentProps<typeof AddressFormContainerInternal>,
  | 'address'
  | 'clearErrors'
  | 'error'
  | 'errors'
  | 'fetchingAddress'
  | 'setFetchingAddress'
  | 'updateAddress'
>;

export function AddressFieldsContainer({
  index,
  ...restProps
}: AddressFieldsContainerProps) {
  const {
    clearErrors,
    updateValueWith,
    fetchingAddress,
    setFetchingAddress,
    errors,
    getValue,
  } = useFormContext();
  const addressKey = index !== undefined ? `addresses.${index}` : 'address';
  const updateAddress = useCallback(
    (update: Record<string, unknown>) => {
      updateValueWith(addressKey, (a: Record<string, unknown>) => ({
        ...a,
        ...update,
      }));
    },
    [addressKey, updateValueWith],
  );

  return (
    <AddressFormContainerInternal
      index={index}
      address={
        getValue(addressKey) as ApiAddressWithFormData | null | undefined
      }
      fetchingAddress={fetchingAddress}
      setFetchingAddress={setFetchingAddress}
      updateAddress={updateAddress}
      clearErrors={clearErrors}
      error={errors[addressKey]}
      errors={errors}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  );
}
